
const convertTime = (time) => {
  let splitTime = time.split(":")
  const min = parseFloat(splitTime[0])
  const sec = parseFloat(splitTime[1])
  return min * 60 + sec
}

const chapterStartText = (chapter, decade, words, voice, sound) => {
  return (
    "CHAPTER " + chapter
    + "\n----------"
    + "\nDecade: " + decade 
    + "\nWords: " + words
    + "\nVoice: " + voice
    + "\nSound: " + sound 
  )
}

const contributors = [
  "Mark Blickley", 
  "Shin Yu Pai", 
  "Trevor Vicks",
  "Kaitlin Losansky", 
  "Jason Hamann", 
  "Rebecca Fernandes",
  "Alina Rios",
  "Sophie Kashman",
  "Ruth Kazmerzak",
  "Anna Wannquist",
  "Ian Frank",
  "Marco Forlin",
  "Cecilia Seaward",
  "Oceana Marie Dunsire",
  "St Celfer",
  "Emma Shafer",
  "Lennox Helmeid",
  "Rob Godman",
  "Jackson McKeehan",
  "Emily Bishop",
  "Ethan Massa",
  "Amber Cortes",
  "Nick Willis",
  "Lisa Schmidt",
  "Aiken Muller",
  "Juli Brown",
  "Gavin Brooks",
  "Brad Muller",
  "Emma Shafer",
  "David Halsell"
]

const organizers = [
  "Aiken Muller",
  "AJ Linder",
  "Amber Cortez",
  "Brad Muller",
  "Clayton Kinney",
  "David Halsell",
  "James Wenlock"
]

const chapterOne = [
  {
    time: 0.0,
    txt: chapterStartText(
      "1", 
      "2100-2109", 
      "Mark Blickley", 
      "Shin Yu Pai", 
      "Trevor Vicks"
    )
  },
  {
    time: 9,
    txt: "Proud Paleo Perfect People! A fruitful and somber D.O.A. Eve everyone!"
  },
  {
    time: 17,
    txt: "We gather around tonight’s sacred flame, on this divine evening, not only for our annual commiseration of the horrific D.O.A.—Dawn of Agriculture, but this year we have reached the milestone of taking our patriotic movement into the cusp of the 22nd Century.  As we spend the night together in this holy place, speaking ancestral truths and not technological malaprops and jargon, we face yet another dawn together that shall deposit us into the year 2100, and the increasingly brutal attempts to subjugate we outlaw PPPPs."
  },
  {
    time: 53,
    txt: "A blessing on all your heads on this D.O.A. Eve, from your family of physically and morally undefiled Paleolithic ancestors. On this holiest night of the year, we echo the ancient betrayal of our true humanity as hunter/gatherers into victims of flabby factory farming, artificial food additives and animal husbandry."
  },
  {
    time: 77.5,
    txt: "We have survived yet another year, indeed, another century, free of the non-Proud Paleo Perfect People vices of sexual possessiveness, poisonous consumption, and corporate property subjugation. We can only entice new PPPP converts if we continue to offer up ourselves as primary source examples of human ecstasy, in both body and spirit. They dare to continue labeling us barbaric domestic terrorists and hunt us down as a threat to their technological corruption and servitude."
  },
  {
    time: 113, 
    txt: "My children! My children!  Come forth and purify yourselves with our annual D.O.A. Eve re-birth ritual, a pageant of truth. Help squeeze the pus out of the pimple known as humanity’s darkest day, the Dawn of Agriculture, as we proudly and defiantly go forth into this new 22nd Century. "
  },
  {
    time: 137,
    txt: "The Washington Cabal obliterated all signs of the Great Famine of 2033, a famine that murdered tens of millions of people. They abolish the ancient books, digitalizing the information they want to keep, and erase what they do not wish us to know. Yet we shall fight and never forget, never forgive, never remain silent.  Our Proud Paleo Perfect People PPPP oral histories shall always preserve and present the truth."
  },
  {
    time: 169,
    txt: "Evening has given way to night. Let us not succumb to the encircling darkness that has surrounded our sacred tribe ever since that first vile cultivated grain yeast infection rose up to mutilate our humanity 14, 536 years ago."
  },
  {
    time: 188.5,
    txt: "Tonight, we renew our pledge to refuse to be slapped into a shadow of sexual shame by the D.O.A. Dawn of Agriculture’s rape of our topsoil’s life-giving inches of dirt, amidst the fertilized stench of domesticated animal dung."
  },
  {
    time: 205,
    txt: "Proud Paleo Perfect People! A reading from the sacred book of Holy Homeostasis:\n\n“Evolution is a conscious process.”\n “Animal ranches and cultivated grains give birth to unnaturally wicked food.”\n“Better Dead Than Bread!”\n“Praise be to the Lard, and all other natural byproducts!”"
  }
]

const chapter2Start = 259

const chapterTwo = [
  {
    time: 235,
    txt: chapterStartText(
      "2", 
      "2110-2119", 
      "Kaitlin Losansky", 
      "Jason Hamann", 
      "Rebecca Fernandes"
    )
  },
  {
    time: chapter2Start + 2.5 ,
    txt:   "YOU\nHey Zenith. Turn up the soundscape and holoflame."
  },
  {
    time: chapter2Start + 6.0,
    txt:   "ZENITH\nOkay. Would you like to input more rich wavelength context?\nOutdoor campfire sounds, crackling and nature."
  },
  {
    time: chapter2Start + 9.0,
    txt: "YOU\nYes, please. Make it sound like home."
  },
  {
    time: chapter2Start + 12.0,
    txt: "ZENITH\nOkay. That sounds comforting."
  },
  {
    time: chapter2Start + 15.0,
    txt: "YOU\nIt is… When does my shift end?"
  },
  {
    time: chapter2Start + 19.0,
    txt: "ZENITH\nTomorrow, Tuesday June 18th, 2117, at 23 hundred hours."
  },
  {
    time: chapter2Start + 24.2,
    txt:"YOU\nThanks Zen. Augment the flames and turn down the console lights. I wanna see these sparks fly up so high they look like stars."
  },
  {
    time: chapter2Start + 32.0,
    txt: "ZENITH\nOkay. That’s a great idea."
  },
  {
    time: chapter2Start + 36.7,
    txt: "YOU\nYeah. That’s the shit right there. Best part of the swing shift is that I get the brig to myself. Plenty of room to get lost in my thoughts."
  },
  {
    time: 305.7,
    txt: "ZENITH\nI’m here too."
  },
  {
    time: chapter2Start + 49.0,
    txt: "YOU\nSure… But, and I’m only saying this blunt because I know you don’t have any feelings, you’re not going to be around for much longer. The new wave of Bio Bots will be released soon and after that who knows what. You’ll be obsolete by the time I’m thirty, Zen... but it’s like you just got here. Isn’t that sad?" 
  },
  {
    time: 334,
    txt: "…Zenith?"
  },
  {
    time: 336,
    txt: "ZENITH\nI assumed that was a rhetorical question, my apologies. It is sad."
  },
  {
    time: 340.5,
    txt: "YOU\nIt’s just hard to feel like there’s any… you know what, never mind. I’m not going to let myself get all nihilistic and existential now. I’ll just stare pensively into this holoflame and put that down for my emotional quota."
  },
  {
    time: 361,
    txt: "…Buuuuut if I’m already on that path it makes more sense for me to process verbally than keep it bottled up, right? That’s what people are supposed to do? Talk it out?"
  },
  {
    time: 370, 
    txt: "ZENITH\n I believe-"
  },
  {
    time: 370.8,
    txt: "YOU\nThat was a rhetorical question, Zen."
  },
  {
    time: 373,
    txt: "ZENITH\nMy apologies. Your oscillation between rhetorical and non rhetorical questions confuses me."
  },
  {
    time: 379.7,
    txt: "YOU\nSorry.\nI don’t think I ever learned how to talk about...these things. I feel something and then as soon as I try to explain it, it just - poof! All my thoughts go away. Head empty. Heart full. No words. Will you decrease the lumens of the fire, Zen?"
  },
  {
    time: 402,
    txt: "ZENITH\nOkay. That looks comforting."
  },
  {
    time: 406,
    txt: "YOU\nThanks. Sometimes my eyes strain from staring at this monitor all day… I just want my head to stop hurting. That’s a constant I can never get rid of. No matter the biotech they release, I’ll still have a dehydrated, overworked brain at the end of each shift."
  },
  {
    time: 424.5,
    txt: "It’s funny how the same thing happens every day even though supposedly everything changes all the time. The world changes but I’m not part of it. I float here in space and the universe spins on without me- you know what? Here are the emotions. I found them. I think this is what one might call an epiphany."
  },
  {
    time: 455,
    txt: "I’ve lost my spark. I have no impact on others, I don’t matter to anyone - except you, Zenith, I know. But an Earth fire, like a real fire from home, brings warmth and guidance. It brings people together. Real flames are so bright that they leave an imprint on your eyelids when you close them, but by the time you open your eyes the flames have shifted again, perpetually dancing into another pose. The two constants to flames are that they exist and they illuminate the world around them, and beyond that it’s all up to the world to interpret their impact... Isn’t that cool? That’s rhetorical. I think that’s cool."
  },
  {
    time: 507,
    txt: "That’s what I want to be - changing and moving and growing but at the end of the day, always there to be a gentle source of light. A soft glow flickering in people’s eyes for as long as they choose to look."
  },
  {
    time: 526,
    txt: "The fire crackles on with the beeps and whirls of space."
  }
]

const chapterThree = [
  {
    time: 530,
    txt: chapterStartText(
      "3",
      "2120-2129",
      "Alina Rios",
      "Sophie Kashman",
      "Ruth Kazmerzak"
    )
  },
  {
    time: 591,
    txt: "A machine is making a beeping noise. Rose rushes to it, bangs on it to make it stop."
  },
  {
    time: 595.5,
    txt: "Rose\nStupid thing. It works, it doesn’t work. You just never know, do you?"
  },
  {
    time: 601,
    txt: "Hasn’t made a peep in months. Thought it was dead for good."
  },
  {
    time: 604,
    txt: "But today\nit decides to"
  },
  {
    time: 607,
    txt: "(To the machine) What are you doing eh? Tryin’ to tell me something?"
  },
  {
    time: 611,
    txt: "Then say it. You’ve never held back before"
  },
  {
    time: 615,
    txt: "Or have you?"
  },
  {
    time: 617,
    txt: "Maybe you have, but for fuck’s sake don’t hold back now."
  },
  {
    time: 620,
    txt: "A machine noise that is somehow both new and ancient."
  },
  {
    time: 630,
    txt: "Hi."
  },
  {
    time: 631,
    txt: "Longer machine noise."
  },
  {
    time: 637,
    txt: "(Smiling) Thank you. I mean you’re biased. Obviously. And is this even, you can't see me, can you. God I wish I’d read the manual."
  },
  {
    time: 647,
    txt: "Longer machine noise."
  },
  {
    time: 652,
    txt: "(Laughs) Right\n\nLook at us, talking about manuals and human nature. Typical."
  },
  {
    time: 660,
    txt: "Shorter machine noise."
  },
  {
    time: 662,
    txt: "God, I miss you."
  },
  {
    time: 664,
    txt: "Not just the...obvious stuff you know, like dates and trips, I mean I do think of that trip to Mars a lot, because well it’s a fucking trip to Mars, and in first class, so yes. I’m not above such things. But I miss your coughing and blowing your nose, all allergic, I mean I always knew when you were coming up the stairs. All your strange noises honestly. And the way you cooked, disemboweling the cupboards and fridge of all the spices, sauces, flavors."
  },
  {
    time: 693,
    txt: "The smell of your wool sweaters"
  },
  {
    time: 697,
    txt: "The way you’d look at me."
  },
  {
    time: 700.5,
    txt: "And hold me."
  },
  {
    time: 702,
    txt: "Fuck. Why d’you have to today?"
  },
  {
    time: 705,
    txt: "Shorter machine noise."
  },
  {
    time: 708,
    txt: "You tried before?"
  },
  {
    time: 711,
    txt: "Remember what the salesman said? He said whichever of us...lives will be able to understand the one who"
  },
  {
    time: 719,
    txt: "A short noise of the machine."
  },
  {
    time: 724,
    txt: "Yes. And then he talked about love as the matter that makes this thing work. I thought he was putting us on."
  },
  {
    time: 729,
    txt: "A long noise of the machine."
  },
  {
    time: 732.5,
    txt: "(Laughs.) You did you did. You fucking believed it."
  },
  {
    time: 738.5,
    txt: "I’m going on a date today, first time since"
  },
  {
    time: 742.1,
    txt: "A short noise of the machine."
  },
  {
    time: 745,
    txt: "I’m not"
  },
  {
    time: 746,
    txt: "A short noise of the machine."
  },
  {
    time: 748,
    txt: "I’m not projecting!"
  },
  {
    time: 749.5,
    txt: "A long noise of the machine."
  },
  {
    time: 752,
    txt: "I know. I want me to be happy too."
  },
  {
    time: 758,
    txt: "It’s in half an hour but I can be late. Tell me everything. Where are you? Are you even"
  },
  {
    time: 762,
    txt: "Beep boop"
  },
  {
    time: 766,
    txt: "No! No no. (She bangs on it.) Come back."
  },
  {
    time: 770,
    txt: "The beeping stops. It’s very quiet. Rose’s heavy sigh."
  },
  {
    time: 772,
    txt: "Another time maybe."
  },
  {
    time: 778,
    txt: "Good bye, Tom."
  }
]

const chapterFour = [
  {
    time: 785,
    txt: chapterStartText(
      "4",
      "2130-2139",
      "Anna Wannquist",
      "Ian Frank",
      "Marco Forlin"
    )
  },
  {
    time: 843.5,
    txt: "It’s hard to think that things were ever any different. I mean- growing up we were taught about the ‘revolution’ but I just (pause) I can’t picture it. We were taught to connect with our land, appreciate our food, always (mocking) ‘calculate the cost of our actions’."
  },
  {
    time: 862,
    txt: "Look, I like it here I’m not complaining, really. I just wish they told us more, (frustrated) I’m old enough to know more."
  },
  {
    time: 876.5,
    txt: "Dad showed us some old photographs, but the village doesn’t really like it when he does that, because they were taken with one of those “cameras”."
  },
  {
    time: 886,
    txt: "I wish I could remember what those looked like; I was only three."
  },
  {
    time: 897.5,
    txt: "I think things are harder now, we have to do everything ourselves. We grow and hunt our own food, we build our own homes, make our own clothes. Wouldn’t it have been easier when- I don’t know."
  },
  {
    time: 913,
    txt: "It seems like we made things harder, but dad says, ‘we were a threat to our own existence’. (annoyed) God- he says that all the time."
  },
  {
    time: 924.5,
    txt: "Last time someone tried making something with ‘technology’ they got in a lot of trouble."
  },
  {
    time: 932,
    txt: "They say he was ‘taken away.’ But where? Where do they take the people who don’t agree?"
  },
  {
    time: 946.7,
    txt: "I’m not allowed to go anywhere near the old city, but I want to see it one day. I just need to know."
  },
  {
    time: 961,
    txt: "I have thought about sneaking out with some of my friends, but (pause) we don’t have a plan yet and it’s a long trip."
  },
  {
    time: 969,
    txt: "(excitedly) We could take Jack- my horse. Well, dad says he belongs to the family, but I named him and I spend the most time with him. I have gotten good at riding too; I’m allowed to get food and supplies with him on my own now."
  },
  {
    time: 982.7,
    txt: "I think I could figure out the way to the old city- I would sure get into a lot of trouble for it though. Maybe when I’m older, or I could talk my dad into taking me."
  },
  {
    time: 996.4,
    txt: "He won’t, (defeated) he will never show me.. who am I kidding?"
  },
  {
    time: 1005,
    txt: "Look, I’m not complaining. I like it here, really."
  }
]

const chapterFive = [
  {
    time: 1035,
    txt: chapterStartText(
      5,
      "2140-2149",
      "Cecilia Seaward",
      "Oceana Marie Dunsire",
      "St Celfer"
    ) 
  },
  {
    time: 1065,
    txt: "I like it here, really"
  },
  {
    time: 1074,
    txt: "{|???|}"
  },
  {
    time: 1107,
    txt: "I am an entrusted citizen"
  },
  {
    time: 1122,
    txt: "{|?????|}"
  },
  {
    time: 1130,
    txt: "forgotten | irrelevant | Disfigured, | amputated from core"
  },
  {
    time: 1174,
    txt: "our houses are not raided, our minds are"
  },
  {
    time: 1183,
    txt: "I know who lives better than we do. I will only reveal their names if the situation gets bad enough. For now, I will keep the knowledge to myself."
  },
  {
    time: 1200,
    txt: "Travel is not an option unless you have some particular skill that is needed elsewhere. I am stuck here. "
  },
  {
    time: 1213,
    txt: "I am an entrusted citizen, not a model citizen. I do enough. I do not wish to stir feathers. I look out for myself and my partner first."
  },
  {
    time: 1230,
    txt: "I know the right answers to the questions I may be asked. I consume the daily stories as a way to leave the monotony of my life."
  },
  {
    time: 1242,
    txt: "The stories give my life meaning. We can write our own stories as long as they focus on an acceptable topic. I hope to one day have my story be a daily story."
  },
  {
    time: 1260.5,
    txt: "I wrote this recently, it was not selected as a daily story but maybe it is worth keeping somewhere safe:"
  },
  {
    time: 1271.5,
    txt: "The pageantry of marriage"
  },
  {
    time: 1276,
    txt: "Supposed delicacies roast in the sun\n\nfor too long, forgotten, irrelevant\n\nDisfigured, amputated from core\n\nShe laughs, soothing him once more\n\nA dalliance, a side step, an encore"
  }
]

const chapterSix = [
  {
    time: 1320,
    txt: chapterStartText(
      6,
      "2150-2159",
      "Emma Shafer",
      "Lennox Helmeid",
      "Rob Godman"
    )
  },
  {
    time: 1345.5,
    txt:  "When the opportunity presented itself, we traversed to the Field.\nI wish we could have gone sooner."
  },
  {
    time: 1353,
    txt:  "I am a Greenskeeper.\nMy apprenticeship takes twenty years to complete. \nTwenty-five for most.\nI am in year Twelve.\nIt is a privilege \nTo caretake this sacred land."
  },
  {
    time: 1367,
    txt:  "Once the fires \nThe floods\nExtraordinary temperatures\nUnpredictable ice \nLed to daily destruction,\nWe devised a way to protect the ecosystems that were succumbing to humanity’s disasters."
  },
  {
    time: convertTime("23:01"),
    txt: "Glasshouses."
  },
  {
    time: convertTime("23:07"),
    txt:   "Large scale\nImpenetrable\nMagnificent\nGlasshouses"
  },
  {
    time: convertTime("23:14"),
    txt: "They are utilized for many ecosystems. I am a Greenskeeper in a Field Glasshouse. Ten Prairie Fields are preserved."
  },
  {
    time: convertTime("23:14"),
    txt: "They are utilized for many ecosystems. I am a Greenskeeper in a Field Glasshouse. Ten Prairie Fields are preserved."
  },
  {
    time: convertTime("23:25"),
    txt: "I know I wasn’t supposed to.\nI know what the penalty would be\nAnd I know I shouldn’t be telling you now."
  },
  {
    time: convertTime("23:33"),
    txt:  "It is illegal to linger in a Glasshouse alone. \nWe work in no less than pairs. \nLatex gloves coat our hands Leather boots confine our feet."
  },
  {
    time: convertTime("23:43"),
    txt: "The Ceremony in how we tend the Field is\nStifled,\nUnromantic,\nScientific. "
  },
  {
    time: convertTime("23:51"),
    txt: 'Our manta:\n“We protect the Field“\n"We serve the Field.”\n“We keep the Field alive.”\n\n“I do not wish to stir feathers.\n”Yet...'
  },
  {
    time: convertTime("24:05"),
    txt: "It’s a clear night\nNo smoke\nOr smog\nA rarity  No one enters the Field at night.\n\nWe know the penalty of unnecessary entrance.\n\n\nOutside the Glasshouses\nThere are trees to breath, \nWater to drink, \nFood to eat\nWe have enough.\n\n\nBut"
  },
  {
    time: convertTime("24:27"),
    txt: "it’s far from flourishing"
  },
  {
    time: convertTime("24:41"),
    txt: "I find myself outside the Glasshouse.\n\nI slip off my boots\n\nTuck worn socks inside\n\nI open the door.\n\nSweet smells.\n\nStillness.\n\nThis land is holy."
  },
  {
    time: convertTime("25:01"),
    txt: "I recall a line from an ancient story\nI read in the Daily"
  },
  {
    time: 1505,
    txt: "He danced through the grass, Gloriously alive.\n\nSo\nI dance! "
  },
  {
    time: convertTime("25:13"),
    txt: "My naked fingers wander the Bluestem Prairie grasses\nMy body consumes the Field\n\nTo love so deeply and fully\nBut never embrace\nAnd now I can TOUCH her\nNow I can FEEL her "
  },
  {
    time: convertTime("25:32"),
    txt:  "I pluck a violet as I\nFind my way to the ground\nLaying on my back\nI look up\nThe stars meet my eyes"
  },
  {
    time: convertTime("25:45"),
    txt: "The violet feels like rubbery paper. \nHuh."
  },
  {
    time: convertTime("25:51"),
    txt: "And I just lay\n\n\nAnd lay\n\n\nAnd lay\n\n\nAnd lay\n\n\nAnd lay"
  },
  {
    time: 1567,
    txt: "On my Land.\nIn my Field\nI am finally home."
  }
]

const chapterSeven = [
  {
    time: 1590,
    txt: chapterStartText(
      7,
      "2160-2169",
      "Jackson McKeehan",
      "Emily Bishop",
      "Ethan Massa"
    )
  },
  {
    time: convertTime("26:40"),
    txt: "They don’t tell you about the pressure."
  },
  {
    time: 1605.5,
    txt: "When they tell you what you experience after death...this isn’t what any of us expected."
  },
  {
    time: 1621,
    txt: "I can...sort of do a full visual rotation and see what’s left of my body--or at least, how it’s progressing."
  },
  {
    time: 1621,
    txt: "Everything is pretty fossilized now, I guess\n\nThe amount of earth pushing me back into myself.\n\nDeath is a diamond."
  },
  {
    time: 1631.5,
    txt: "I could hear them up there for a long time, you know? Like, I was up at the top, and I could hear the living ones."
  },
  {
    time: convertTime("27:24"),
    txt: "I don’t know if they’re still there. Sometimes I get just a whiff of a sound. I don’t know if it’s because I lost track of my time, or if this is just how it goes."
  },
  {
    time: convertTime("27:38"),
    txt: "It wasn’t as if we’d done anything too terrible. I mean, I tried. We tried.\n\nWe were trying to regrow."
  },
  {
    time: 1668.5,
    txt: "I remember some sort of a collapse? It was as if.. all we’d rebuilt just caved in on itself."
  },
  {
    time: convertTime("27:58"),
    txt: "The others are here with me.\n\nI can’t see them, of course, I’m dead.\n\nBut I can feel them, and sometimes one of us will tell a memory.\n\nWhat I don’t remember is love."
  },
  {
    time: convertTime("28:15"),
    txt: "I have this word in me, L-O-V-E, and I know how it is supposed to sound.\n\nThe rest of the words there’s still context for in this form, but not love."
  },
  {
    time: 1710.8,
    txt: "It feels important?"
  },
  {
    time: 1713.5,
    txt: "I heard one of the others scream it some time back.\n\nI feel like the weight of this earth on me has squeezed the meaning out of it and it might never come back."
  },
  {
    time: convertTime("28:45"),
    txt: "Some of the others have been pressed into dirt. That feels lucky to me. I hope they went somewhere else.\n\nMaybe they’re back up on top, trying the re-growth process again."
  },
  {
    time: convertTime("29:01"),
    txt: "I said it a lot up there, that word, Love, back when we were still bodies."
  },
  {
    time: convertTime("29:07"),
    txt: "I don’t remember to whom."
  },
]

const chapterEight = [
  {
    time: 1772,
    txt: chapterStartText(
      "8",
      "2170-2179",
      "Amber Cortes",
      "Nick Willis",
      "Lisa Schmidt"
    ),
  },
  {
    time: convertTime("30:26"),
    txt: "At some point, some exact moment in time, it all changed."
  },
  {
    time: convertTime("30:36"),
    txt: "Remember time?"
  },
  {
    time: convertTime("30:38"),
    txt: "The way it made us put one foot in front of the other because we thought we had to? "
  },
  {
    time: convertTime("30:44"),
    txt: "Before we knew we could make it bend?"
  },
  {
    time: convertTime("30:47"),
    txt: "Before it all went wrong,"
  },
  {
    time: 1850.8,
    txt: "before we got stuck here?"
  },
  {
    time: 1863.5,
    txt: "Anyway, I couldn’t tell you the exact moment, but at some point, we started to sing."
  },
  {
    time: 1873,
    txt: "Well, when I say “we” I mean I don’t know who exactly. Someone sewn into the earth started it."
  },
  {
    time: convertTime("31:23"),
    txt: "And I when I say “sing” I don’t mean like a song the way you might think of one."
  },
  {
    time: 1891,
    txt: "(Remember music? The way we danced when we were on top of the ground? Arms linked, eyes locked?)"
  },
  {
    time: 1903,
    txt: "But what reverberated through the dirt wasn’t music—at first."
  },
  {
    time: convertTime("31:49"),
    txt: "It was more like a low, rumbling sound, a kind of dark hum dense enough to puncture our very cellular walls."
  },
  {
    time: convertTime("31:59"),
    txt: "One by one, the song warmed its way through us, crawled inside what was left of our memories."
  },
  {
    time: convertTime("32:10"),
    txt: "And each time that happened, each time the song touched one of us it got stronger, louder, as the frequency became higher."
  },
  {
    time: convertTime("32:24"),
    txt: "Subtle harmonies started emerging as we found and joined our voices, each one’s story, like spores, multiplying—but also unifying."
  },
  {
    time: convertTime("32:40"),
    txt: "This time, we wouldn’t collapse. This time we would get it right"
  },
  {
    time: 1967, 
    txt: "You could tell from that song, the way it had no middle and no end, the way it rose and fell with the motions of eternal breath."
  },
  {
    time: convertTime("33:01"),
    txt: "And, one by one, it happened—we started waking up."
  },
  {
    time: convertTime("33:06"),
    txt: "We were re-growing once again."
  },
  {
    time: convertTime("33:11"),
    txt: "But this time it would be different, because the living ones were still up there."
  },
  {
    time: 2002,
    txt: "There was only one thing left to do."
  }
]

const chapterNine = [
  {
    time: convertTime("33:34"),
    txt: chapterStartText(
      9,
      "2180-2189",
      "Aiken Muller",
      "Juli Brown",
      "Gavin Brooks"
    )
  },
  {
    time: convertTime("34:02"),
    txt: "I live on the west bank, just south of the New Tip."
  },
  {
    time: 2046,
    txt: "I stand on the shore and Look north to where my life used to be. Though crumbled and cracked, I recognize the patterns of highs and lows, I see half of where I used to roam."
  },
  {
    time: 2061.5,
    txt: "How far could it be? Two miles? Maybe 3?"
  },
  {
    time: convertTime("34:30"),
    txt: "Water does a great job of distorting my perception of distance.\n\nMaybe it’s not the water, maybe it’s that I never could see a mass so clear in the distance before.\n\nOn the coast, it’s just water. "
  },
  {
    time: convertTime("34:49"),
    txt: "There is nothing to measure against."
  },
  {
    time: convertTime("34:54"),
    txt: "And in the Old Town, well something towered above to block your view every 100 feet."
  },
  {
    time: convertTime("35:01"),
    txt: "But now, 3? 4? Some distance away is the shoreline of what used to be. And I know they are thinking the same thing. "
  },
  {
    time: convertTime("35:16"),
    txt: "3? 4?"
  },
  {
    time: convertTime("35:26"),
    txt: "As I wade in the water and draw my fingers along the jagged shoreline the sounds rush back into my head. Hums, harmonies, a symphony of echoes that vibrated soothingly through the ground running up through our feet and settling into my chest."
  },
  {
    time: 2147,
    txt: "Is the memory still clear? Or is this half memory half dream, something interpreted by a child and distorted to the adult."
  },
  {
    time: convertTime("36:01"),
    txt: "I was only 11 when we split."
  },
  {
    time: convertTime("36:11"),
    txt: "If I close my eyes I can see the outlines of the vase spinning on its edge as the buzzing in my chest grew until the soothing vibrations became a painful shake, enveloping my senses."
  },
  {
    time: 2184,
    txt: "The harmonies became dissonant and the pitches became piercing---"
  },
  {
    time: 2188.5,
    txt: "Or was that me screaming for it to stop?"
  },
  {
    time: convertTime("36:38"),
    txt: "the voices became lower, rumbling to the point I could no longer hear it but only feel. This must’ve opened my ears to the screaming around me. "
  },
  {
    time: convertTime("36:52"),
    txt: "But, no. That must've been the dream."
  },
  {
    time: convertTime("36:56"),
    txt: "Because before long we were all clutching our hearts and falling to our knees. Covering our heads, wishing the ear could close."
  },
  {
    time: convertTime("37:06"),
    txt: "Embracing the end as the ground split beneath us."
  },
  {
    time: convertTime("37:14"),
    txt: "I live on the west bank, just south of the New Tip."
  },
  {
    time: convertTime("37:19"),
    txt: "To my right, the farthest horizon, though flattened, looks mostly as it did. But I know out of my reach are the Hundred Islands that were never supposed to be."
  },
  {
    time: 2253,
    txt: "To my left, the ocean. The one true reminder of what was. "
  }
]

const chapterTen = [
  {
    time: convertTime("37:48"),
    txt: chapterStartText(
      "10",
      "2190-2199",
      "Brad Muller",
      "Emma Shafer",
      "David Halsell"
    ),
  },
  {
    time: 2303,
    txt: "When I decided to become a geologist, I would never have imagined……. in my wildest dreams……that I’d end up becoming so intrigued with ascetic practice – better known as the kind of stuff that monks do…"
  },
  {
    time: convertTime("38:42"),
    txt: "To me the world was about substance and structure and constituted spaces."
  },
  {
    time: convertTime("38:50"),
    txt: "The 100 Islands Project was about solving the unsolvable – a seismic event not connected to any understood  geological tension or otherwise plausible explanation."
  },
  {
    time: 2344,
    txt: "The fact that it could be man-made was unthinkable at the time."
  },
  {
    time: convertTime("39:16"),
    txt: "It was only because of the Culture Wall that jammed any form of physical or electronic contact – who ever heard of a physical landmass that cannot be photographed?"
  },
  {
    time: convertTime("39:25"),
    txt: "we figured out the only way we could sketch out what the One Hundred Islands looked like, geologically, was through seismic reflection and refraction … I know boring…"
  },
  {
    time: convertTime("39:39"),
    txt: "It took a long time to map the islands as you can imagine, triangulating pulses and echoes,  but as many people now know, it became the only piece of “outside world” information that the One Hundred Islands people allowed through the Culture Wall."
  },
  {
    time: 2397,
    txt: "And hence my mini geek stardom and public adoration"
  },
  {
    time: convertTime("40:02"),
    txt: "– just kidding –"
  },
  {
    time: convertTime("40:04"),
    txt: "Kinda…"
  },
  {
    time: convertTime("40:06"),
    txt: "Of the many things we have offered to them over the years, this single and massive library of data  - a sonic record of their geology – is the only thing that they have accepted from our separate society."
  },
  {
    time: convertTime("40:22"),
    txt: "I think now that they may have… fallen in love with it, for lack of a better way to describe it."
  },
  {
    time: 2431,
    txt: "We can now hear the sounds being reproduced and even manipulated"
  },
  {
    time: convertTime("40:55"),
    txt: "– in regular intervals that suggest a ritual or designed practice."
  },
  {
    time: convertTime("41:01"),
    txt: "We know from pre-event records discovered a few years ago that the seismic activity that formed the Islands was planned, that separation from society was their goal."
  },
  {
    time: 2473,
    txt: "We don’t understand much about their current practices yet, but these sounds are the first clue."
  },
  {
    time: 2483.5,
    txt: "I wonder what their fascination with these sounds is – "
  },
  {
    time: 2488.5,
    txt: "Sounds that are not a call to a god, sounds that solve no problem, that follow no rules, that cannot be referred to with words."
  },
  {
    time: convertTime("41:40"),
    txt: "Sounds that cannot glorify egos nor raise idols -  for what purpose is this practice?"
  },
  {
    time: convertTime("41:49"),
    txt: "But I also get it in some way, like me, they love their geology."
  },
  {
    time: convertTime("42:00"),
    txt: "campfire crackles"
  },
  {
    time: 2542,
    txt: "Thank you for listening to cmpfr.22c, that's all, goodbye"
  },
]

const chapters = {
  chapterTxt: [
    ...chapterOne,
    ...chapterTwo,
    ...chapterThree,
    ...chapterFour,
    ...chapterFive,
    ...chapterSix,
    ...chapterSeven,
    ...chapterEight,
    ...chapterNine,
    ...chapterTen
  ],
  chapterStart: [
    chapterOne[0].time,
    chapterTwo[0].time,
    chapterThree[0].time,
    chapterFour[0].time,
    chapterFive[0].time,
    chapterSix[0].time,
    chapterSeven[0].time,
    chapterEight[0].time,
    chapterNine[0].time,
    chapterTen[0].time
  ],
  contributors: contributors,
  organizers: organizers
}

export default chapters